import React from 'react';
import { Link } from 'react-router-dom';

const Siddharthainternational = () => 
<>    

         <div className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/aboutUs.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 caption text-center">
                            <h1>Siddhartha International</h1>
                            <h4>Travel Agents & Tour Operator</h4>
                        </div>
                    </div>
                </div>
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </div>


            <section className="about section-padding bg-white" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-title">Siddhartha International</div>
                            <div className="row">
                                <div className="col-lg-9 col-md-12">
                                    <p>Siddhartha International Tours and Travel Company, founded by Mr. Manoj Saluja in 1996, is a recognized and trusted name in the travel industry, approved by the Department of Tourism, Government of India. With over three decades of expertise, we offer personalized travel experiences, exploring India's rich cultural heritage and natural beauty. From spiritual pilgrimages to luxurious retreats, our expert team crafts unforgettable journeys. Discover hidden gems, iconic landmarks, and local traditions with us.</p>
                                       <p><img src="img/location.png" loading="lazy" alt="pin" class="locto" />802, 8th Floor, New Delhi House, 27, Barakhamba Road, New Delhi - 110001</p>
                                <a href="https://www.siddharthainternational.com/" className="butn-dark2" target="_blank" rel="noopener noreferrer">
                                    View Details
                                </a>
                                </div>
                                <div className="col-lg-3 col-md-12">
                                    <img className="img-fluid rounded w-100 wow zoomIn" data-wow-delay="0.3s" src="img/rooms/central-hotel.jpg" alt='' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


</>;

export default Siddharthainternational;